import axios from "../config"

class NotiService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getNoti() {
        let url = `/noti`
        return axios.get(url).then(request => request.data);
    }
    getNotiCount() {
        let url = `/noti/count`
        return axios.get(url).then(request => request.data);
    }
}

const service = new  NotiService();
export default service;